import type { Location } from 'react-router-dom';
import type { IUser } from '@/@types/User';

type LocationLike = Pick<Location, 'pathname' | 'search' | 'hash'>;
type UserInfoLike = Pick<
  IUser,
  'onboarding_step' | 'documentation_status' | 'contract_signed'
>;

export function buildReturnTo(location: LocationLike): string {
  return location.pathname + location.search + location.hash;
}

export function getContractRedirectTarget(
  location: LocationLike,
  userInfo: UserInfoLike | null | undefined,
): string | null {
  if (location.pathname === '/contract') return null;

  const isFinishedOnboarding = userInfo?.onboarding_step === 'finished';
  const documentsApproved = userInfo?.documentation_status === 'approved';
  const isSigned = userInfo?.contract_signed === true;

  if (isFinishedOnboarding && documentsApproved && !isSigned) {
    const from = buildReturnTo(location);
    return `/contract?returnTo=${encodeURIComponent(from)}`;
  }

  return null;
}

export function getReturnToFromContract(location: LocationLike): string | null {
  if (location.pathname !== '/contract') return null;

  const params = new URLSearchParams(location.search);
  const redirectTo = params.get('returnTo') ?? params.get('redirectTo');
  if (!redirectTo) return null;
  if (!redirectTo.startsWith('/') || redirectTo.startsWith('//')) return null;
  if (redirectTo === '/contract' || redirectTo.startsWith('/contract?')) {
    return null;
  }

  return redirectTo;
}
